import { action, makeAutoObservable, observable } from 'mobx'

import { TimetableModel } from 'sections/LKSection/shared/PickPointSharedModule/models/TimetableModel/TimetableModel'

export class OrderWorkConditionsViewModel {
  @observable area: string | null = null
  @observable warehouseArea: string | null = null
  @observable dressingRoomsCount: string | null = null
  @observable cellingHeight: string | null = null

  @observable timetable = new TimetableModel()

  constructor() {
    makeAutoObservable(this)
  }

  @action
  setArea = (value: string | null) => {
    this.area = value
  }

  @action
  setWarehouseArea = (value: string | null) => {
    this.warehouseArea = value
  }

  @action
  setDressRoomsCount = (value: string | null) => {
    this.dressingRoomsCount = value
  }

  @action
  setCellingHeight = (value: string | null) => {
    this.cellingHeight = value
  }

  @action
  reset = () => {
    this.setArea(null)
    this.setWarehouseArea(null)
    this.setDressRoomsCount(null)
    this.setCellingHeight(null)
    this.timetable.reset()
  }
}
